export const STATUS_ID_MAP: Record<string, number | number[]> = {
  total: [1, 2, 3, 4, 5, 6],
  sample_collected: 1,
  trf_generated: 2,
  handed_over: 3,
  report_uploaded: 4,
  resampling_required: 5,
  report_delayed: 6,
};

export const INCOMING_STATUS_ID_MAP: Record<string, number | number[]> = {
  total: [1, 2, 3, 4, 5],
  pending_for_pickup: 1,
  picked: 2,
  report_uploaded: 3,
  sample_rejected: 4,
  report_delayed: 5,
};
